import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-380064e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pedidos-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "pedidos-content" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"page-header\" data-v-380064e8><div class=\"header-left\" data-v-380064e8><div class=\"header-icon\" data-v-380064e8><i class=\"lni lni-package\" data-v-380064e8></i></div><div data-v-380064e8><h1 class=\"page-title\" data-v-380064e8>Gestión de Pedidos</h1><p class=\"page-subtitle\" data-v-380064e8>Administración · Seguimiento y confirmación de órdenes</p></div></div></div>", 1);
const _hoisted_5 = { class: "filters-bar" };
const _hoisted_6 = { class: "search-wrapper" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-search search-icon" }, null, -1 /* HOISTED */));
const _hoisted_8 = { class: "filter-group" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-funnel filter-icon" }, null, -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Todos los estados", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Pendiente", -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Pago Pendiente de Verificación", -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Preparando", -1 /* HOISTED */));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Confirmado", -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Pagado", -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "En envío", -1 /* HOISTED */));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Completado", -1 /* HOISTED */));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", null, "Rechazado", -1 /* HOISTED */));
const _hoisted_19 = [
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18
];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-reload" }, null, -1 /* HOISTED */));
const _hoisted_21 = {
    key: 0,
    class: "results-count"
};
const _hoisted_22 = { class: "table-card" };
const _hoisted_23 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner-ring" }, null, -1 /* HOISTED */));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Cargando pedidos...", -1 /* HOISTED */));
const _hoisted_26 = [
    _hoisted_24,
    _hoisted_25
];
const _hoisted_27 = {
    key: 1,
    class: "data-table"
};
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Código Pedido"),
        /*#__PURE__*/ _createElementVNode("th", null, "Vendedor"),
        /*#__PURE__*/ _createElementVNode("th", null, "Comprador"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Total"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_29 = { key: 0 };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "empty-cell"
}, [
    /*#__PURE__*/ _createElementVNode("div", { class: "empty-state" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-empty-file" }),
        /*#__PURE__*/ _createElementVNode("p", null, "No hay pedidos que coincidan con los filtros.")
    ])
], -1 /* HOISTED */));
const _hoisted_31 = [
    _hoisted_30
];
const _hoisted_32 = { class: "code-badge" };
const _hoisted_33 = { class: "user-cell" };
const _hoisted_34 = { class: "user-avatar seller" };
const _hoisted_35 = { class: "font-medium" };
const _hoisted_36 = { class: "user-cell" };
const _hoisted_37 = { class: "user-avatar buyer" };
const _hoisted_38 = { class: "text-muted" };
const _hoisted_39 = { class: "text-center" };
const _hoisted_40 = { class: "text-end" };
const _hoisted_41 = { class: "price-tag" };
const _hoisted_42 = { class: "text-center" };
const _hoisted_43 = ["onClick"];
const _hoisted_44 = { class: "modal-header-premium" };
const _hoisted_45 = { class: "modal-title-group" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-package" })
], -1 /* HOISTED */));
const _hoisted_47 = { class: "modal-title-text" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "modal-subtitle" }, "Detalles completos de la orden", -1 /* HOISTED */));
const _hoisted_49 = { class: "modal-body-scroll" };
const _hoisted_50 = { class: "info-grid" };
const _hoisted_51 = { class: "info-card" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Comprador", -1 /* HOISTED */));
const _hoisted_53 = { class: "info-value" };
const _hoisted_54 = { class: "info-card" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Vendedor", -1 /* HOISTED */));
const _hoisted_56 = { class: "info-value" };
const _hoisted_57 = { class: "info-card" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Fecha", -1 /* HOISTED */));
const _hoisted_59 = { class: "info-value" };
const _hoisted_60 = { class: "info-card" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Estado", -1 /* HOISTED */));
const _hoisted_62 = { class: "info-card highlight" };
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Total del Pedido", -1 /* HOISTED */));
const _hoisted_64 = { class: "info-total" };
const _hoisted_65 = { class: "products-section" };
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "products-title" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-list" }),
    /*#__PURE__*/ _createTextVNode(" Productos del Pedido ")
], -1 /* HOISTED */));
const _hoisted_67 = { class: "product-list" };
const _hoisted_68 = ["src"];
const _hoisted_69 = {
    key: 1,
    class: "product-thumb-placeholder"
};
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-package" }, null, -1 /* HOISTED */));
const _hoisted_71 = [
    _hoisted_70
];
const _hoisted_72 = { class: "product-info" };
const _hoisted_73 = { class: "product-name-row" };
const _hoisted_74 = { class: "product-name" };
const _hoisted_75 = { class: "product-meta-grid" };
const _hoisted_76 = { class: "meta-item" };
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("b", null, "Vendedor:", -1 /* HOISTED */));
const _hoisted_78 = { class: "meta-item" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("b", null, "Cant. Solicitada:", -1 /* HOISTED */));
const _hoisted_80 = { class: "meta-item" };
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("b", null, "Cant. Confirmada:", -1 /* HOISTED */));
const _hoisted_82 = { class: "meta-item" };
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("b", null, "Precio Unit.:", -1 /* HOISTED */));
const _hoisted_84 = { class: "meta-item highlight-meta" };
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("b", null, "Subtotal:", -1 /* HOISTED */));
const _hoisted_86 = {
    key: 2,
    class: "product-action"
};
const _hoisted_87 = ["onClick"];
import { ref, computed, onMounted } from "vue";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/HeaderDashboard.vue";
import Swal from "sweetalert2";
import { EyeIcon, XIcon, CheckCircleIcon } from 'lucide-vue-next';
import { PedidoService } from "@/services/PedidoService";
import { formatCurrency } from "@/utils/formatPrice";
import { config } from '@/config';
import { hasPermission } from '@/store/userStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const isLoading = ref(false);
        const esVendedor = ref(true);
        const pedidos = ref([]);
        const pedidoSeleccionado = ref(null);
        const modalVisible = ref(false);
        const busqueda = ref("");
        const filtroEstado = ref("");
        const pedidosFiltrados = computed(() => pedidos.value.filter(p => {
            const matchesBusqueda = p.nombreComprador.toLowerCase().includes(busqueda.value.toLowerCase()) ||
                p.nombreVendedor.toLowerCase().includes(busqueda.value.toLowerCase()) ||
                p.codigoPedido.toLowerCase().includes(busqueda.value.toLowerCase());
            const matchesEstado = filtroEstado.value ? p.estado === filtroEstado.value : true;
            return matchesBusqueda && matchesEstado;
        }));
        const limpiarFiltros = () => { busqueda.value = ""; filtroEstado.value = ""; };
        const formatFecha = (fecha) => fecha ? new Date(fecha).toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" }) : "";
        const getEstadoClase = (estado) => {
            const map = {
                "Pendiente": "pill-warning",
                "Pago Pendiente de Verificación": "pill-amber",
                "Preparando": "pill-blue",
                "Confirmado": "pill-indigo",
                "Pagado": "pill-green",
                "En envío": "pill-cyan",
                "Completado": "pill-success",
                "Rechazado": "pill-danger",
            };
            return map[estado] ?? "pill-default";
        };
        const abrirModalDetalles = (pedido) => {
            pedidoSeleccionado.value = pedido;
            modalVisible.value = true;
        };
        const cerrarModal = () => { modalVisible.value = false; };
        const getImagen = (imagen) => imagen ? `${config.API_URL}/${imagen}` : require("@/assets/paquete.png");
        onMounted(async () => {
            isLoading.value = true;
            try {
                const response = await PedidoService.getTodosPedidos();
                if (response.exito)
                    pedidos.value = response.datos;
            }
            catch (error) {
                Swal.fire("Error", "No se pudieron cargar los pedidos", "error");
            }
            finally {
                isLoading.value = false;
            }
        });
        const confirmarStock = async (producto) => {
            try {
                const result = await Swal.fire({
                    title: "Confirmación de Stock",
                    text: `¿El stock de ${producto.nombreRepuesto} está completo, parcial o no disponible?`,
                    icon: "question",
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonText: "Completo",
                    cancelButtonText: "Parcial",
                    denyButtonText: "No tiene",
                    confirmButtonColor: "#10b981",
                    denyButtonColor: "#ef4444",
                });
                let nuevoEstado = "";
                let nuevaCantidad = producto.cantidadConfirmada ?? 0;
                if (result.isConfirmed) {
                    nuevoEstado = "Completo";
                    nuevaCantidad = producto.cantidadSolicitada;
                }
                else if (result.dismiss === Swal.DismissReason.cancel) {
                    const { value: cantidad } = await Swal.fire({
                        title: "Cantidad disponible",
                        input: "number",
                        inputLabel: `Cantidad disponible de ${producto.nombreRepuesto}`,
                        inputPlaceholder: "Ingrese la cantidad",
                        showCancelButton: true,
                        inputValidator: (value) => {
                            if (!value || isNaN(Number(value)) || Number(value) <= 0)
                                return "Ingrese una cantidad válida.";
                            if (Number(value) > producto.cantidadSolicitada)
                                return `No puede superar: ${producto.cantidadSolicitada}`;
                            return null;
                        },
                    });
                    if (!cantidad)
                        return;
                    nuevoEstado = "Parcial";
                    nuevaCantidad = Number(cantidad);
                }
                else if (result.isDenied) {
                    nuevoEstado = "Sin stock";
                    nuevaCantidad = 0;
                }
                else
                    return;
                const confirmacionFinal = await Swal.fire({
                    title: "¿Está seguro?",
                    text: `Stock de ${producto.nombreRepuesto}: ${nuevoEstado} (${nuevaCantidad} unidades).`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí, confirmar",
                    confirmButtonColor: "#10b981",
                });
                if (!confirmacionFinal.isConfirmed)
                    return;
                isLoading.value = true;
                await PedidoService.confirmarProducto({ confirmacionId: producto.confirmacionVendedorID, cantidadConfirmada: nuevaCantidad });
                const response = await PedidoService.getTodosPedidos();
                if (response.exito) {
                    pedidos.value = response.datos;
                    if (pedidoSeleccionado.value) {
                        const actualizado = pedidos.value.find(p => p.pedidoId === pedidoSeleccionado.value.pedidoId);
                        if (actualizado)
                            pedidoSeleccionado.value = actualizado;
                    }
                }
                Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Stock confirmado', showConfirmButton: false, timer: 2000 });
            }
            catch (error) {
                Swal.fire("Error", "No se pudo confirmar el stock.", "error");
            }
            finally {
                isLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar),
                    _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" ── Page Header ── "),
                        _hoisted_4,
                        _createCommentVNode(" ── Filters Bar ── "),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((busqueda).value = $event)),
                                    placeholder: "Buscar por comprador, vendedor o código de pedido...",
                                    class: "search-input"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, busqueda.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filtroEstado).value = $event)),
                                    class: "filter-select"
                                }, _hoisted_19, 512 /* NEED_PATCH */), [
                                    [_vModelSelect, filtroEstado.value]
                                ])
                            ]),
                            _createElementVNode("button", {
                                class: "btn-clear",
                                onClick: limpiarFiltros
                            }, [
                                _hoisted_20,
                                _createTextVNode(" Limpiar ")
                            ]),
                            (!isLoading.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(pedidosFiltrados.value.length) + " pedido(s) ", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" ── Table ── "),
                        _createElementVNode("div", _hoisted_22, [
                            _createCommentVNode(" Loading "),
                            (isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                                : (_openBlock(), _createElementBlock("table", _hoisted_27, [
                                    _hoisted_28,
                                    _createElementVNode("tbody", null, [
                                        (pedidosFiltrados.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_31))
                                            : _createCommentVNode("v-if", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedidosFiltrados.value, (pedido) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: pedido.pedidoId,
                                                class: "table-row"
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", _hoisted_32, _toDisplayString(pedido.codigoPedido), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _createElementVNode("div", _hoisted_34, _toDisplayString(pedido.nombreVendedor?.[0] ?? 'V'), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_35, _toDisplayString(pedido.nombreVendedor), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_36, [
                                                        _createElementVNode("div", _hoisted_37, _toDisplayString(pedido.nombreComprador?.[0] ?? 'C'), 1 /* TEXT */),
                                                        _createElementVNode("span", null, _toDisplayString(pedido.nombreComprador), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_38, _toDisplayString(formatFecha(pedido.fechaCreacion)), 1 /* TEXT */),
                                                _createElementVNode("td", _hoisted_39, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["estado-pill", getEstadoClase(pedido.estado)])
                                                    }, _toDisplayString(pedido.estado), 3 /* TEXT, CLASS */)
                                                ]),
                                                _createElementVNode("td", _hoisted_40, [
                                                    _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(formatCurrency)(pedido.total)), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("td", _hoisted_42, [
                                                    _createElementVNode("button", {
                                                        class: "btn-action",
                                                        onClick: ($event) => (abrirModalDetalles(pedido)),
                                                        title: "Ver detalles"
                                                    }, [
                                                        _createVNode(_unref(EyeIcon), { size: 16 })
                                                    ], 8 /* PROPS */, _hoisted_43)
                                                ])
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]))
                        ])
                    ])
                ]),
                _createCommentVNode(" ── Modal Detalles Pedido ── "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        (modalVisible.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: cerrarModal
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-window",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createCommentVNode(" Modal Header "),
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, [
                                            _hoisted_46,
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h2", _hoisted_47, "Pedido #" + _toDisplayString(pedidoSeleccionado.value?.codigoPedido), 1 /* TEXT */),
                                                _hoisted_48
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: cerrarModal,
                                            class: "btn-modal-close"
                                        }, [
                                            _createVNode(_unref(XIcon), { size: 20 })
                                        ])
                                    ]),
                                    _createCommentVNode(" Modal Body "),
                                    _createElementVNode("div", _hoisted_49, [
                                        _createCommentVNode(" Info Grid "),
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("div", _hoisted_51, [
                                                _hoisted_52,
                                                _createElementVNode("span", _hoisted_53, _toDisplayString(pedidoSeleccionado.value?.nombreComprador), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                                _hoisted_55,
                                                _createElementVNode("span", _hoisted_56, _toDisplayString(pedidoSeleccionado.value?.nombreVendedor), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_57, [
                                                _hoisted_58,
                                                _createElementVNode("span", _hoisted_59, _toDisplayString(pedidoSeleccionado.value?.fechaCreacion ? formatFecha(pedidoSeleccionado.value.fechaCreacion) : ''), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_60, [
                                                _hoisted_61,
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["estado-pill sm", getEstadoClase(pedidoSeleccionado.value?.estado ?? '')])
                                                }, _toDisplayString(pedidoSeleccionado.value?.estado), 3 /* TEXT, CLASS */)
                                            ]),
                                            _createElementVNode("div", _hoisted_62, [
                                                _hoisted_63,
                                                _createElementVNode("span", _hoisted_64, _toDisplayString(_unref(formatCurrency)(pedidoSeleccionado.value?.total ?? 0)), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _createCommentVNode(" Productos "),
                                        _createElementVNode("div", _hoisted_65, [
                                            _hoisted_66,
                                            _createElementVNode("div", _hoisted_67, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedidoSeleccionado.value?.detalles, (producto, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: index,
                                                        class: "product-row"
                                                    }, [
                                                        (producto.imagenUrl)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: getImagen(producto.imagenUrl),
                                                                alt: "Producto",
                                                                class: "product-thumb"
                                                            }, null, 8 /* PROPS */, _hoisted_68))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71)),
                                                        _createElementVNode("div", _hoisted_72, [
                                                            _createElementVNode("div", _hoisted_73, [
                                                                _createElementVNode("span", _hoisted_74, _toDisplayString(producto.nombreRepuesto), 1 /* TEXT */),
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["confirm-badge", producto.confirmado ? 'confirmed' : 'pending'])
                                                                }, _toDisplayString(producto.confirmado ? 'Confirmado' : 'Pendiente'), 3 /* TEXT, CLASS */)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_75, [
                                                                _createElementVNode("span", _hoisted_76, [
                                                                    _hoisted_77,
                                                                    _createTextVNode(" " + _toDisplayString(producto.nombreVendedor), 1 /* TEXT */)
                                                                ]),
                                                                _createElementVNode("span", _hoisted_78, [
                                                                    _hoisted_79,
                                                                    _createTextVNode(" " + _toDisplayString(producto.cantidadSolicitada), 1 /* TEXT */)
                                                                ]),
                                                                _createElementVNode("span", _hoisted_80, [
                                                                    _hoisted_81,
                                                                    _createTextVNode(" " + _toDisplayString(producto.cantidadConfirmada), 1 /* TEXT */)
                                                                ]),
                                                                _createElementVNode("span", _hoisted_82, [
                                                                    _hoisted_83,
                                                                    _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(producto.precioVenta)), 1 /* TEXT */)
                                                                ]),
                                                                _createElementVNode("span", _hoisted_84, [
                                                                    _hoisted_85,
                                                                    _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(producto.precioVenta * producto.cantidadSolicitada)), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]),
                                                        (!producto.confirmado && esVendedor.value && _unref(hasPermission)('ORD_MANAGE'))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                                _createElementVNode("button", {
                                                                    class: "btn-confirm-stock",
                                                                    onClick: ($event) => (confirmarStock(producto))
                                                                }, [
                                                                    _createVNode(_unref(CheckCircleIcon), { size: 15 }),
                                                                    _createTextVNode(" Confirmar Stock ")
                                                                ], 8 /* PROPS */, _hoisted_87)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ]),
                                    _createCommentVNode(" Modal Footer "),
                                    _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            class: "btn-modal-cancel",
                                            onClick: cerrarModal
                                        }, "Cerrar")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
